import {Map} from "@esWebAPI/es/map"

import _ from "lodash";

export default class AddressSearcherApi {
    private geocodeServiceUrlTemplate = 'https://atlas.microsoft.com/search/{searchType}/json?typeahead=true&limit={limit}&subscription-key={subscription-key}&api-version=1&query={query}&language={language}&lon={lon}&lat={lat}&topLeft={topLeft}&btmRight={btmRight}';
    private mapBounds: number[] = [];
    private mapCenter: number[] = [];
    private isBusinessSearch: boolean = false;

    /**
     * 
     * @param map 
     * @param userSettings 
     * @param tenant 
     * 
     * @returns 
     */
    public initialize(map: Map, userSettings: any, tenant: any) {
        if (!map) {
            console.warn("AddressSearcherApi initialize map is null");
            return;
        }

        const businessSearchProfiles = tenant.profile === "BASE" || tenant.profile === "ENTERPRISE";
        this.isBusinessSearch =  !es.isPublicAccess && businessSearchProfiles;

        const onUpdateViewCallback = () => {
            const newBounds = map.baseMap.getBounds();
            const newCenter = map.baseMap.getCenter();
            this.mapBounds[0] = newBounds[0];
            this.mapBounds[1] = newBounds[1];
            this.mapBounds[2] = newBounds[2];
            this.mapBounds[3] = newBounds[3];

            this.mapCenter[0] = newCenter[0];
            this.mapCenter[1] = newCenter[1];
        }

        map.eventChannel.addListener('onUpdateView', onUpdateViewCallback);

        onUpdateViewCallback();
        if (userSettings.searchCountries.length) {
            this.geocodeServiceUrlTemplate += '&countrySet=' + userSettings.searchCountries;
        }
    }

    /**
     * 
     * @param longitude 
     * 
     * @returns 
     */
    private wrapLong(longitude: number): number {
        if (longitude < -180) {
            longitude = longitude % 360 + 180;
        }

        if (longitude > 180) {
            longitude = 180 - longitude % 360;
        }

        return longitude;
    }

    /**
     * 
     * @param searchTerm 
     * @param center 
     * @param bounds 
     * 
     * @returns 
     */
    public search(searchTerm: string, center?: number[], bounds?: number[]) {

        let mapBounds = bounds ? bounds : this.mapBounds;
        let mapCenter = center ? center : this.mapCenter;

        const dfd = $.Deferred();

        const requestUrl = this.geocodeServiceUrlTemplate.replace('{query}', encodeURIComponent(searchTerm))
            .replace('{searchType}', this.isBusinessSearch ? "fuzzy" : "address")
            .replace('{subscription-key}', es.azureMapsKey)
            .replace('{language}', 'en-US')
            .replace('{lon}', ''+this.wrapLong(mapCenter[0]))    //Use a lat and lon value of the center the map to bias the results to the current map view.
            .replace('{lat}', ''+mapCenter[1])

            .replace('{topLeft}',  ''+[this.wrapLong(mapBounds[3]), mapBounds[0]])
            .replace('{btmRight}', ''+[this.wrapLong(mapBounds[1]), mapBounds[2]])
            .replace('{limit}', '20');

        $.ajax({
            url: requestUrl,
            success: (data) => {
                const results = data.results.map((item: any) => {
                    return {
                        name : item.poi ? item.poi.name : "",
                        poi : item.poi,
                        formatted_address : item.address.freeformAddress,
                        geometry : {
                            location : {
                                lat : item.position.lat,
                                lng : item.position.lon
                            }
                        }
                    };
                });

                dfd.resolve(_.uniq(results));
            }
        });

        return dfd;
    }
}
